// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"advertising_buttonWrapper__bxZ9u","button":"advertising_button__g13pC"};